<template>
  <BDropdown
    variant="outline-secondary"
    size="sm"
    class="saved-view-dropdown"
    menu-class="w-100 shadow-sm  scroll-y scroll-on-hover"
    toggle-class="d-flex justify-content-between align-items-center w-100 text-start"
    no-caret
  >
    <template #button-content>
      <span class="text-truncate me-2" style="max-width: 220px;">
        {{ modelValue ? modelValue.title : placeholder }}
      </span>
      <ChevronDown :size="14" class="opacity-50" />
    </template>

    <!-- Create New -->
    <BDropdownItem @click="handleCreate">
      <div class="d-flex align-items-center py-1 small">
        <Plus :size="16" class="me-2" />Neue Ansicht Erstellen
      </div>
    </BDropdownItem>

    <!-- Saved Views -->
    <template v-if="savedViews && savedViews.length">
      <BDropdownItem
        v-for="view in savedViews"
        :key="view.id"
        @click="handleSelect(view)"
        :active="modelValue && modelValue.id === view.id"
      >
        <div class="d-flex flex-column py-1">
          <span class="small fw-medium">{{ view.title }}</span>
          <span class=" small" style="font-size: 0.75rem;">{{ view.subtitle }}</span>
        </div>
      </BDropdownItem>
    </template>

    <BDropdownDivider />

    <!-- Description -->
    <div class="px-3 py-2 text-muted" style="font-size: 0.7rem; line-height: 1.3;">
      Vordefinierte Sonderreports mit spezifischen Filter- und KPI-Kombinationen für besondere Analysen.
    </div>

    <!-- Special Reports (Scrollable) -->
    <div class="scrollable-menu">
      <BDropdownItem
        v-for="report in specialReports"
        :key="report.id"
        @click="handleSelect(report)"
        :active="modelValue && modelValue.id === report.id"
      >
        <div class="d-flex flex-column py-1">
          <span class="fw-medium">{{ report.title }}</span>
          <span class="text-muted small" style="font-size: 0.75rem;">{{ report.subtitle }}</span>
        </div>
      </BDropdownItem>
    </div>
  </BDropdown>
</template>

<script>
import { ChevronDown, Plus } from 'lucide-vue-next';

export default {
  name: 'SavedViewSelection',
  components: { ChevronDown, Plus },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Gespeicherte Ansicht Auswählen...'
    }
  },
  emits: ['update:modelValue', 'create-view'],
  data() {
    return {
      savedViews: [
        { id: 'v1', title: 'Mystery Shopping Q4 2024', subtitle: 'Standard-Ansicht für Q4/2024 Performance' },
        { id: 'v2', title: 'Alle Marken Jahresübersicht 2025', subtitle: 'Vergleich aller Marken über alle Wellen 2025' }
      ],
      specialReports: Array.from({ length: 3 }, (_, i) => ({
        id: `sr${i+1}`,
        title: `Sonderreport ${i+1}`,
        subtitle: 'Spezialauswertung • Vorkonfiguriert'
      }))
    }
  },
  methods: {
    handleSelect(item) {
      this.$emit('update:modelValue', item);
    },
    handleCreate() {
      this.$emit('create-view');
    }
  }
}
</script>

<style scoped>
.scrollable-menu {
  /* max-height: 300px;
  overflow-y: auto; */
}

</style>
